import script from "./action-show-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./action-show-dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__